import { Capacitor } from "@capacitor/core";

const PRODUCTION_URL = "https://stasht.app";

/**
 * Get shareable URL for the current page.
 * On Capacitor (mobile), use production URL instead of capacitor://localhost
 */
export function getShareableUrl(path?: string): string {
  // If we're on Capacitor (mobile app), always use production URL
  if (Capacitor.isNativePlatform()) {
    const currentPath = path || window.location.pathname + window.location.search + window.location.hash;
    return `${PRODUCTION_URL}${currentPath}`;
  }

  // On web, use current URL
  if (path) {
    return `${window.location.origin}${path}`;
  }
  return window.location.href;
}

/**
 * Get shareable URL for a specific path
 */
export function getShareableUrlForPath(path: string): string {
  return Capacitor.isNativePlatform()
    ? `${PRODUCTION_URL}${path}`
    : `${window.location.origin}${path}`;
}
